<template>
  <div>
    <b-row>
      <b-col>
        <span class="booking-details-title d-block rounded mb-2">
          <h4 class="mb-0" v-translate>Service Fee</h4>
          <hr class="my-1" style="border-color:white;">
          <p class="mb-0" v-translate>Here you can add the agency commission in order to be able to send your client the offer in PDF format directly from our reservations system. Simple and fast!</p>
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <table class="table table-sm text-center">
          <thead class="t-head thead-light text-center">
            <tr>
              <td>No. stars</td>
              <td>Commission/room/package </td>
              <td>Commission/room/package (%)Percentage</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="stars in order" :key="'fee' + stars">
              <td>
                {{ stars ? (stars + '*') : $gettext('No classification')}}
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].value"
                  size="sm" />
                </b-form-group>
              </td>
              <td>
                <b-form-group class="mb-0">
                <b-input
                  type="number"
                  v-model="fees[stars].percent"
                  size="sm" />
                </b-form-group>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'HotelFeesEdit',
  props: ['fees'],
  data () {
    return {
      order: [5, 4, 3, 2, 1, 0]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
